import { ValidAccountRoute } from '@ferreri/minato-auth-react';
import { SectionInstallPWA } from '@ferreri/prever-component-lib';
import { PageLayoutMenuFooter } from '../components/PageLayoutMenuFooter';
import { Home } from '../modules/home/Home';
import { PAGE_TITLE } from '../utils/pageTitle';
import { SkeletonHomePage } from '../components/skeletons/SkeletonHomePage';
import { GetServerSideProps } from 'next';
import { SETTINGS } from '../config/settings';

export default function HomePage() {
  return (
    <>
      <SectionInstallPWA />
      <ValidAccountRoute loadingComponent={<SkeletonHomePage />}>
        <PageLayoutMenuFooter pageTitle={PAGE_TITLE.home}>
          <Home />
        </PageLayoutMenuFooter>
      </ValidAccountRoute>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  if (SETTINGS.server.maintenance === 'true') {
    return { redirect: { destination: '/maintenance', permanent: false } };
  }

  return {
    props: {},
  };
};
